import React, { Component, createElement } from "react";
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker
} from "react-google-maps";
import { InfoWindow } from "react-google-maps";
import "whatwg-fetch";
import {
    formatPhoneNumber,
    formatZipcode,
    formatUrl
} from "./../modules/formattingHelpers";

const defaultMapOptions = {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false
};

const WrappedOrganizationComponent = withScriptjs(
    withGoogleMap(props => (
        <GoogleMap
            defaultZoom={11}
            defaultCenter={{ lat: 51.960242, lng: 6.262433 }}
            defaultOptions={defaultMapOptions}
        >
            <React.Fragment>{props.children}</React.Fragment>
        </GoogleMap>
    ))
);

class InfoWindowOrganization extends Component {
    render() {
        return (
            <article className="organization__info-window">
                <h1>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: this.props.organization.title.rendered
                        }}
                    ></span>{" "}
                </h1>

                <address>
                    {this.props.organization.acf.pp_gids_street}{" "}
                    {this.props.organization.acf.pp_gids_house_number}
                    {this.props.organization.acf.pp_gids_suite}, <br />
                    {formatZipcode(
                        this.props.organization.acf.pp_zip_code
                    )}{" "}
                    {this.props.organization.acf.pp_gids_city}
                    <br />
                    <br />
                    {this.props.organization.acf.pp_gids_url ? (
                        <span>
                            <a href={this.props.organization.acf.pp_gids_url}>
                                {formatUrl(
                                    this.props.organization.acf.pp_gids_url
                                )}
                            </a>{" "}
                        </span>
                    ) : null}
                </address>

                <a href={this.props.organization.link}>
                    Bekijk deze organisatie
                </a>
            </article>
        );
    }
}

export default class OrganizationMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeOrganizationId: null
        };
    }

    renderInfoWindow(organization) {
        if (this.state.activeOrganizationId !== organization.id) {
            return null;
        }

        return (
            <InfoWindow
                onCloseClick={() => {
                    this.setState({
                        activeOrganizationId: null
                    });
                }}
            >
                <InfoWindowOrganization organization={organization} />
            </InfoWindow>
        );
    }

    renderMarkers() {
        if (this.props.organizations === undefined) {
            return null;
        }

        return this.props.organizations.map(organization => {
            if (organization.acf.pp_gids_gps_location == undefined) {
                return null;
            }

            const lat = parseFloat(
                organization.acf.pp_gids_gps_location.split(",")[0]
            );
            const lng = parseFloat(
                organization.acf.pp_gids_gps_location.split(",")[1]
            );

            var icon = {
                url:
                    "/wp-content/themes/oost-gelre-multisite/images/locationPointer.svg"
            };

            return (
                <Marker
                    key={organization.id}
                    icon={icon}
                    position={{ lat, lng }}
                    onClick={() => {
                        this.setState({
                            activeOrganizationId: organization.id
                        });
                    }}
                >
                    {this.renderInfoWindow(organization)}
                </Marker>
            );
        });
    }

    render() {
        return (
            <WrappedOrganizationComponent
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyC-LVoWdOxD2u76uIahDK1ArlHutA_EREc&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div className="section section--map" />}
                mapElement={<div style={{ height: `100%` }} />}
            >
                {this.renderMarkers()}
                <div className="iframe__text editor rewrite-css-vars">
                    De sociale kaart
                </div>
            </WrappedOrganizationComponent>
        );
    }
}
